module.exports = __webpack_public_path__ + "images/banners/for_company_banner_9d13fae7b6d3d259d5bb4241866c9e3b.png";